// @ts-ignore
import CryptoJS from 'crypto-js';
export const encryptPwd = function encryptPwd(password: string, key: string): any {
    let secretPassword = '';
    if (password.length == 0) {
        return secretPassword;
    }
    for (let i = 0; i < password.length; i++) {
        secretPassword = secretPassword + password.charAt(i) + getRandom();
    }
    password = secretPassword;
    key = CryptoJS.enc.Utf8.parse(key);
    let realpass = '';
    for (let i = 0; i < password.length; i++) {
        if (i % 2 === 0) {
            realpass = realpass + password.charAt(i);
        }
    }
    const encrypted = CryptoJS.DES.encrypt(realpass, key, { iv: key });
    password = encrypted.toString();
    return password;
};
export const decrypt = function encryptPwd(message: string, key: string): any {
    // 将密文转换成Base64格式
    const ciphertext = CryptoJS.enc.Base64.parse(message);
    // 使用DES算法进行解密
    const decrypted = CryptoJS.DES.decrypt({ ciphertext }, CryptoJS.enc.Utf8.parse(key), {
        iv: CryptoJS.enc.Utf8.parse(key),
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7
    });
    return decrypted.toString(CryptoJS.enc.Utf8);
};
const getRandom = function () {
    return Math.ceil(Math.random() * 9);
};
